import React, { Fragment, useEffect, useState } from 'react';
import queryString from 'query-string';
import PurchaseDetails from './purchaseDetails/purchaseDetails';
import BillingDetails from './billingDetails/billingDetails';
import AddressGSTDetails from './addressGSTDetails/addressGSTDetails';
import ShippingDetails from './shippingDetails/shippingDetails';
import PlanSummaryCard from './planSummaryCard/planSummaryCard';
import ActionCall from './actionCall/actionCall';
import './commonSummary.scss';
import { createOrder, submitOrderForSummary, updateOrderForSummary, validateOrderAsync, summaryAuthToken, validateTokenForOrder } from '../../../common/services/http.service';
import { getFromSessionStorage, setInSessionStorage, findParamFromUrl, showServiceError, isOrderSubmittedByCustomer, removeUserSessionData } from '../../../common/utils/app.utils';
import { AUTHORIZATION_HEADER, MODULE_ID, SUMMARY_AUTHORIZATION_HEADER, SELECTED_PARTY_ACCOUNT } from '../../../home/common/constants/constants';
import { fetchOrder } from '../../../common/services/http.service';
import FooterComponent from './footer/footer';
import { getRequestForOrderUpdate, isOrderConfirmationUrl } from '../../services/summary.service';
import { GENERIC_ERROR_MESSAGE, ORDER_TYPE, PRODUCT_NAME, ROUTES } from '../../../common/constants/app.constants';
import { useHistory } from 'react-router-dom';
import StepsHeader from '../../../home/components/functional/steps-header/steps.component';
import MainLoader from 'b2b-ui-components-lib/lib/components/roundLoader';
import { faOnDedicatedSummaryPageLoad } from '../../services/analytics.service';
// import { Notification, NOTIFICATION_TYPE } from 'common/components/notification-component/notification-component';
import { Notification, NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';
import { DEFAULT_TOAST_MSG, NOTIFICATION_ACTION } from 'home/view/manage-feasibility/constants';
import ShiftingSummary from './ShiftingSummary';
import { saveOrder } from 'tokenGeneration/lead.util';

function Summary(props) {
  const { isUnAuthJourney } = props;
  const partyId = findParamFromUrl('partyId') ? findParamFromUrl('partyId') : getFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
  const orderIdFromParam = findParamFromUrl('orderId', false);
  const isTMORedirect = findParamFromUrl('journey', false) === 'trackLead';

  const orderType = findParamFromUrl('type', false);
  const authTokenFromUrl = findParamFromUrl('auth', false);

  const [orderDetail, setOrderDetail] = useState({});
  const [ovRemarks, setOvRemarks] = useState('');
  const [isOrderLoaded, setIsOrderLoaded] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [notification, setNotification] = useState({ show: false, email: '', message: '', hideNotificaton: false });
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [isOrderConfirmation, setIsOrderConfirmation] = useState(isOrderConfirmationUrl());
  const history = useHistory();
  const [formStatus, setFormStatus] = useState({
    shippingDetails: false,
    purchaseDetail: true,
    billingDetails: false,
    addressGSTDetail: false
  });
  const [formData, setFormData] = useState({
    shippingDetails: null,
    purchaseDetail: null,
    billingDetails: null,
    addressGSTDetail: null
  });
  const [customerAccounts, setCustomerAccounts] = useState([]);

  const isShiftingOrder = () => {
    return orderDetail?.orderType === 'CHANGE_ORDER' && orderDetail?.orderSubType === 'SHIFTING';
  };

  const handleNotficationEvent = ({ nodeInfo, event, innerText }) => {
    const { action } = nodeInfo;
    switch (action) {
      case NOTIFICATION_ACTION.ORDER_CONFIRMATION: {
        if (isShiftingOrder()) {
          setShowEmailPopup(true);
        } else {
          doFetchOrder(setShowEmailPopup);
        }
        break;
      }
      default:
        break;
    }
  };

  const createOrderPayload = {
    leadAuthorizationToken: getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER),
    serviceType: getFromSessionStorage(MODULE_ID, PRODUCT_NAME),
    orderSource: 'ONLINE_ACQ'
  };

  const redirectToThankYou = (submitOrderRes = {}, order, isSubmitted = false) => {
    const {
      lead: {
        customer: { partyId, segment },
        lineItemCount = ''
      },
      orderId,
      orderStatus
    } = order;
    if (isOrderSubmittedByCustomer(orderStatus) || isSubmitted) {
      const dateStamp = (submitOrderRes && submitOrderRes.data && submitOrderRes.data.result && submitOrderRes.data.result.submittedAt) || '';
      let redirectUrl = ROUTES.DEDICATED_THANK_YOU;
      history.push(redirectUrl, {
        leadId: orderId,
        userType: segment,
        hideNetworkSteps: true,
        via: 'SUMMARY',
        isThankYouAuth: true,
        noOfCircuits: lineItemCount,
        dateStamp
      });
    } else if (orderStatus === ORDER_TYPE.ORDER_CANCELLED) {
      let redirectUrl = ROUTES.DEDICATED_CANCEL;
      if (partyId) {
        redirectUrl = redirectUrl + '?partyId=' + partyId;
      }
      history.push(redirectUrl, { leadId: orderId, userType: segment, hideNetworkSteps: true, via: 'SUMMARY', isThankYouAuth: true, noOfCircuits: lineItemCount });
    }
  };

  const submitOrder = () => {
    submitOrderForSummary().then(
      (resp) => {
        redirectToThankYou(resp, orderDetail, true);
      },
      (error) => {
        console.error(error);
        setShowLoader(false);
        const errorMsg = (error && error.response && error.response.data && error.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;

        showServiceError({
          show: true,
          data: errorMsg,
          redirect: false
        });
      }
    );
  };

  const updateOrder = () => {
    const orderRequest = getRequestForOrderUpdate({ ...formData }, orderDetail, false, customerAccounts);
    return updateOrderForSummary(orderRequest);
  };

  const updateParentForm = (updatedForm) => {
    setFormData((prevState) => {
      return { ...prevState, ...updatedForm };
    });
  };

  const updateFormStatus = (formStatus) => {
    setFormStatus((prevState) => {
      return { ...prevState, ...formStatus };
    });
  };

  const isFormValid = () => {
    return formStatus.addressGSTDetail && formStatus.billingDetails && formStatus.purchaseDetail && formStatus.shippingDetails;
  };

  const checkOrderConfirmationStatus = ({ orderStatus }) => {
    const status = (orderStatus && [ORDER_TYPE.ORDER_CONFIRMATION, ORDER_TYPE.ORDER_CONFIRMATION_PENDING]).includes(orderStatus) || isOrderConfirmationUrl();
    setIsOrderConfirmation(status);
  };

  const doFetchOrder = (setShowEmailPopup = () => {}) => {
    setShowLoader(true);
    fetchOrder().then(
      ({ data }) => {
        if (data && data.success && data.result) {
          const order = data.result;
          if (data.result.serviceType) {
            setInSessionStorage(MODULE_ID, PRODUCT_NAME, order.serviceType);
          }
          saveOrder(order);
          setOrderDetail(order);
          setOvRemarks(order && order.remarks);
          setIsOrderLoaded(true);
          redirectToThankYou({}, order);
          setShowEmailPopup(true);
          checkOrderConfirmationStatus(order);
        }
        setShowLoader(false);
      },
      (err) => {
        setShowLoader(false);
        console.error(err);
        if (isOrderConfirmation) {
          history.push(ROUTES.B2B_FAILURE);
        }
      }
    );
  };

  const disableBackButton = () => {
    window.history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      window.history.pushState(null, null, document.URL);
    });
  };

  const generateSummaryAuthTokenForTMORedirect = (accessToken, orderId, partyId) => {
    setShowLoader(true);
    let payLoad = {};
    payLoad.aehAccessToken = accessToken;
    payLoad.orderId = orderId;
    payLoad.partyId = partyId;
    summaryAuthToken(payLoad).then(
      ({ headers }) => {
        const authorization = headers['authorization'];
        setInSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER, authorization);
        doFetchOrder();
        setShowLoader(false);
      },
      (err) => {
        setShowLoader(false);

        let redirectUrl = ROUTES.ERROR_PAGE;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }
        history.push(redirectUrl);
      }
    );
  };

  const handleSubmitClick = () => {
    console.log('@@@@');
    if (isOrderConfirmation) {
      const route = findParamFromUrl('type', false) ? `${ROUTES.CONFIRM_INSTALLATION}?type=${findParamFromUrl('type', false)}` : ROUTES.CONFIRM_INSTALLATION;
      props.history.push(route);
    } else {
      handleValidateOrder();
    }
  };

  const handleValidateOrder = () => {
    try {
      setShowLoader(true);
      // update order
      updateOrder().then(
        (updateOrderRes) => {
          if (updateOrderRes?.data?.success) {
            // validate order details
            const params = {
              validationType: 'BILLING'
            };
            validateOrderAsync(params).then(
              (validateOrderRes) => {
                setShowLoader(false);
                if (validateOrderRes?.data?.success) {
                  props.history.push(ROUTES.CONFIRM_INSTALLATION);
                }
              },
              (validateOrderErr) => {
                const errorMsg = (validateOrderErr && validateOrderErr.response && validateOrderErr.response.data && validateOrderErr.response.data.errorMsg) || DEFAULT_TOAST_MSG;
                setShowLoader(false);
                showServiceError({
                  show: true,
                  data: errorMsg,
                  redirect: false
                });

                // // MOCK RESPONSE ***mock
                // props.history.push(ROUTES.CONFIRM_INSTALLATION);
                throw new Error(errorMsg);
              }
            );
          }
        },
        (updateOrderErr) => {
          const errorMsg = (updateOrderErr && updateOrderErr.response && updateOrderErr.response.data && updateOrderErr.response.data.errorMsg) || DEFAULT_TOAST_MSG;
          setShowLoader(false);
          showServiceError({
            show: true,
            data: errorMsg,
            redirect: false
          });
          throw new Error(errorMsg);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    faOnDedicatedSummaryPageLoad();
    disableBackButton();
    const orderId = orderIdFromParam;
    const accessToken = localStorage.getItem('accessToken');
    const currentSummaryAuthToken = getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER);
    let params = queryString.parse(window && window.location.search);
    if (params && params.Authorization) {
      setInSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER, params.Authorization);
      doFetchOrder();
    } else if (orderId && accessToken && !currentSummaryAuthToken && isTMORedirect) {
      generateSummaryAuthTokenForTMORedirect(accessToken, orderId, partyId);
    } else if (!currentSummaryAuthToken && !isOrderConfirmation && !isTMORedirect) {
      setShowLoader(true);
      createOrder(createOrderPayload).then(
        ({ headers }) => {
          const authorization = headers['authorization'];
          setInSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER, authorization);
          doFetchOrder();
        },
        (err) => {
          const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
          setShowLoader(false);
          showServiceError({
            show: true,
            data: errorMsg,
            redirect: false
          });
        }
      );
    } else if (isUnAuthJourney === true && authTokenFromUrl && orderId && orderType === ORDER_TYPE.ORDER_CONFIRMATION) {
      validateTokenForOrder(authTokenFromUrl, orderType, orderId).then(
        (response) => {
          setInSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER, authTokenFromUrl);
          doFetchOrder();
          setShowLoader(false);
        },
        (err) => {
          setShowLoader(false);
          removeUserSessionData();
          props.history.push(ROUTES.B2B_FAILURE);
        }
      );
    } else {
      doFetchOrder();
    }
  }, []);
  return (
    <React.Fragment>
      {showLoader ? (
        <div className="container round-loader">
          <MainLoader />

          <p className="loader-heading">
            <span className="color-red">Loading…</span>
            <br />
            Please Wait.
          </p>
        </div>
      ) : (
        <React.Fragment>
          <Notification
            onCancel={() => setNotification({ show: false, hideNotificaton: true })}
            show={notification.show && !notification.hideNotificaton}
            type={NOTIFICATION_TYPE.ORDER_CONFIRMATION}
            message={notification.message}
            eventHandler={handleNotficationEvent}
          />
          <StepsHeader
            disabledChoosePlan={true}
            disabled={true}
            activeStepIndex={4}
            isdedicatedJourney={true}
            isUnAuthJourney={false}
            showFeasibilityStatus={''}
            orderDetail={orderDetail}
          />
          {isShiftingOrder() ? (
            <Fragment>
              <ShiftingSummary orderDetail={orderDetail} />
              <FooterComponent
                setNotification={setNotification}
                order={orderDetail}
                formData={formData}
                isFormValid={isFormValid()}
                submitOrder={submitOrder}
                updateOrder={updateOrder}
                fetchOrder={doFetchOrder}
                showEmailPopup={showEmailPopup}
                setShowEmailPopup={setShowEmailPopup}
                isOrderConfirmation={isOrderConfirmation}
                onSubmitClick={handleSubmitClick}
              ></FooterComponent>
            </Fragment>
          ) : (
            <section className="order_summary_form plan-page">
              <div className="row">
                <div className="flg-lg-9 flg-md-12">
                  {/* <h5 className="b2b-lib-accordionContainer header-name">Review and Submit Order</h5> */}
                  {ovRemarks && (
                    <div className="ovRemarks-msg">
                      <span className="material-icons icon-image-preview vertical-bottom">report_problem</span>
                      <b>Feedback Shared By Order Verification Team: </b>
                      {ovRemarks}
                    </div>
                  )}
                  {isOrderLoaded && (
                    <React.Fragment>
                      <PurchaseDetails updateParentForm={updateParentForm} setFormStatus={updateFormStatus} order={orderDetail} isOrderConfirmation={isOrderConfirmation} />
                      <BillingDetails
                        order={orderDetail}
                        updateParentForm={updateParentForm}
                        setFormStatus={updateFormStatus}
                        isOrderConfirmation={isOrderConfirmation}
                        setOrderDetail={setOrderDetail}
                        setCustomerAccounts={setCustomerAccounts}
                      />
                      <AddressGSTDetails order={orderDetail} updateParentForm={updateParentForm} setFormStatus={updateFormStatus} isOrderConfirmation={isOrderConfirmation} />
                      <ShippingDetails order={orderDetail} updateParentForm={updateParentForm} setFormStatus={updateFormStatus} isOrderConfirmation={isOrderConfirmation} />
                      <FooterComponent
                        setNotification={setNotification}
                        order={orderDetail}
                        formData={formData}
                        isFormValid={isFormValid()}
                        submitOrder={submitOrder}
                        updateOrder={updateOrder}
                        fetchOrder={doFetchOrder}
                        showEmailPopup={showEmailPopup}
                        setShowEmailPopup={setShowEmailPopup}
                        isOrderConfirmation={isOrderConfirmation}
                        onSubmitClick={handleSubmitClick}
                      ></FooterComponent>
                    </React.Fragment>
                  )}
                </div>
                <div className="flg-lg-3 flg-md-12">
                  <div className="cardBox">
                    {isOrderLoaded && (
                      <React.Fragment>
                        <div className="flg-lg-12 flg-md-6 planSummary">
                          <PlanSummaryCard order={orderDetail} />
                        </div>
                        {/* <div className="flg-lg-12 flg-md-6 actionCall">
   
                                      <ActionCall order = {orderDetail} />
   
                                  </div>  */}
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
export default Summary;
